<template>
	<div class="page">
        <Events/>
	</div>
</template>

<script lang="ts" setup>
import Events from "./data-table-components/general/Events.vue"
import { NButton, NSpace } from "naive-ui"
import { type LabelPlacement, type Size } from "naive-ui/es/form/src/interface"
import { ref } from "vue"

</script>

<style lang="scss" scoped>
.components-list {
	grid-template-columns: none;
}
.card-css {
    background-color: var(--bg-color);
}
</style>
